<template>
    <div>
        <FullPageLoader :isLoading="fullpageLoading"/>

        <div class="row">
            <div class="column small-8">
                <PageTitle title="Creditfacturen" :total="total" :loading="loading"
                    description="Creditfacturen zijn aan te maken op de detailpagina van een factuur of via het optie-menu."
                />
            </div>
            <div class="column small-4 text-right">
                <!-- Credit invoice creation button -->
                <b-button
                    type="is-dark"
                    @click="showCreditInvoiceDialog = true"
                    class="marginbottom10"
                >
                    Nieuw
                </b-button>
                <b-field class="cancelledswitch">
                    <span class="label">Toon betaalde creditfacturen</span><b-switch v-model="showPaidOrders" type="is-success"></b-switch>
                    <!-- <b-button type="is-dark" tag="router-link" v-if="type == 'los'" :to="{ name: 'CreateInvoiceRecord', query: {type: 'los'} }">Nieuw</b-button> -->
                </b-field>
                <b-field class="cancelledswitch">
                    <span class="label">Toon geannuleerde creditfacturen</span>
                    <b-switch v-model="showCancelledOrders" type="is-success"></b-switch>
                </b-field>
                <!-- <b-button type="is-dark" tag="router-link" v-if="!hideCreditButton" :to="{ name: 'CreditInvoiceRecord' }">Creditfactuur aanmaken</b-button> -->
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                    class="table-with-dropdown"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" field="number" label="Factuur nr." width="160">
                            <router-link :to="{ name: 'InvoicesRecord', params: {type: 'credit', id: props.row.id} }">
                                <strong>{{ props.row.number }}</strong>
                            </router-link>
                        </b-table-column>

                        <b-table-column v-slot="props" field="customer" label="Klant" sortable>
                            <b-button tag="router-link" type="is-text" size="is-small" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }" v-if="props.row.customer">
                                <span v-if="hideSensitiveData">********</span>
                                <span v-else>
                                    {{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}
                                    <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                                        <br>
                                        <strong>
                                            <span v-if="props.row.customer.companyname.length >= 27">
                                                <b-tooltip :label="props.row.customer.companyname" position="is-top">
                                                    {{ props.row.customer.companyname|truncate(25, '..') }}
                                                </b-tooltip>
                                            </span>
                                            <span v-else>{{ props.row.customer.companyname }}</span>
                                        </strong>
                                    </span>
                                </span>
                            </b-button>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="customer.type" label="Type" sortable>
                            <span v-if="hideSensitiveData">********</span>
                            <span v-else>{{ props.row.customer.type == 'normal' ? 'Particulier' : props.row.customer.type == 'business' ? 'Zakelijk' : props.row.customer.type == 'foundation' ? 'Stichting' : props.row.customer.type }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="status" label="Status" width="120" sortable>
                            <!-- <b-tag :type="_.isNull(props.row.status) ? 'is-dark' : props.row.status == 'paid' ? 'is-success' : _.includes(['multiple_fails', 'storno'], props.row.status) ? 'is-danger' : _.includes(['one_fail'], props.row.status) ? 'is-warning' : _.includes(['cancelled', 'reminder_1', 'reminder_2'], props.row.status) ? 'is-warning' : 'is-info'">{{ invoiceStatus(props.row.status) }}</b-tag> -->
                            <InvoiceStatus
                                :id="props.row.id"
                                :status="props.row.status"
                                :send_at="props.row.send_at"
                                :type="type"
                                :contract="props.row.contract"
                            />
                        </b-table-column>

                        <b-table-column v-slot="props" field="total_price" label="Totaal" width="100" numeric>
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.total" class="text-danger">-&nbsp;€&nbsp;{{ props.row.total }}</span>
                            <span v-else>-</span>
                        </b-table-column>

                        <!-- <b-table-column v-slot="props" label="Factuur datum" width="240" sortable>
                            <span>{{ props.row.invoice_date|humanDate }}</span>
                        </b-table-column> -->

                        <b-table-column v-slot="props" field="send_at" label="Verstuurd" width="120" sortable>
                            <span v-if="props.row.send_at">
                                {{ props.row.send_at|humanDate }}
                            </span>
                            <span v-else>Nee</span>
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <InvoiceOptionsDropdown
                                type="credit"
                                :record="props.row"
                                @reloadInvoices="loadAsyncData"
                            />
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen creditfacturen gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>

        <!-- Credit Invoice Creation Dialog -->
        <b-modal
            v-model="showCreditInvoiceDialog"
            :can-cancel="['escape', 'outside']"
            has-modal-card
            :destroy-on-hide="false"
        >
            <div class="modal-card" style="width: 600px; max-width: 90vw;">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        <i class="fas fa-exclamation-triangle" style="color: #ff9800; margin-right: 10px;"></i>
                        Creditfactuur aanmaken
                    </p>
                </header>

                <section class="modal-card-body" style="border-radius:0;">
                    <div class="content">
                        <div class="notification is-warning is-light">
                            <strong>Let op:</strong> Je kunt een creditfactuur aanmaken zonder referentie naar een factuur, maar dit wordt niet aangeraden. Bij het openen van een factuur (of via het optie-menu) kun je een creditfactuur aanmaken met referentie naar de originele factuur.
                        </div>

                        <h5>Waarom een credit factuur van een bestaande factuur maken?</h5>
                        <ul style="list-style: none; margin-left: 0;">
                            <li><strong><font-awesome-icon icon="check" class="text-success" />&nbsp;Betere referentie:</strong> De creditfactuur is gekoppeld aan de originele factuur en daarom makkelijk terug te vinden.</li>
                            <li><strong><font-awesome-icon icon="check" class="text-success" />&nbsp;Automatische verrekening:</strong> Prijzen kunnen automatisch met elkaar worden verrekend, waardoor er minder transacties en boekingen gedaan hoeven te worden.</li>
                            <li><strong><font-awesome-icon icon="check" class="text-success" />&nbsp;Minder fouten:</strong> Alle gegevens worden automatisch overgenomen.</li>
                            <li><strong><font-awesome-icon icon="check" class="text-success" />&nbsp;Overzichtelijk contract:</strong> Als de factuur gemaakt is vanuit een contract, is bij het contract de creditfactuur terug te vinden.</li>
                        </ul>
                    </div>
                </section>

                <footer class="modal-card-foot">
                    <b-button @click="showCreditInvoiceDialog = false">
                        Annuleren
                    </b-button>
                    <b-button
                        type="is-dark"
                        @click="createCreditInvoiceWithoutReference"
                        tag="router-link"
                        :to="{ name: 'CreditInvoiceRecord', query: { 'no-reference': true } }"
                    >
                        Doorgaan zonder referentie
                    </b-button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import InvoiceOptionsDropdown from '@/vue/invoices/components/InvoiceOptionsDropdown'
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'
// import excelExportingMixin from '@/mixins/excelExportMixin'

export default {
    name: 'CreditInvoiceOverview',

    components: {
        InvoiceOptionsDropdown
    },

    mixins: [filtersMixin, paramsMixin],

    data() {
        return {
            records: [],

            total: null,
            loading: false,
            fullpageLoading: false,
            sortField: 'invoice_date',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            type: 'credit',
            page: 1,
            perPage: 35,
            searchParams: _.has(this.$store.state.searchQueries, ['CreditInvoiceOverview']) ? this.$store.state.searchQueries['CreditInvoiceOverview'] : null,
            showCancelledOrders: this.$store.state.showCancelledOrders,
            showPaidOrders: this.$store.state.showPaidOrders,
            showCreditInvoiceDialog: false
        }
    },

    computed: {
        paginated() {
            return this.records && this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },
        // hideCreditButton() {
        //     let hideButton = false

        //     if(_.has(this.user.organisation_settings, 'strictcredits') && this.user.organisation_settings.strictcredits == 1 && (this.user.role != 'pit' && !this.user.is_admin) || (this.type == 'credit')){
        //         hideButton = true
        //     }

        //     return hideButton
        // }
    },

    created(){
        // Check if in this session a query is saved (last success) else use default sorting.
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    methods: {
        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, `CreditInvoiceOverview`)

            this.loading = true

            axios.get(`/api/invoices?type=credit&${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: `CreditInvoiceOverview`, query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching credit invoices:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },
        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        },

        createCreditInvoiceWithoutReference() {
            this.showCreditInvoiceDialog = false
            // The router-link in the button will handle the navigation
        }
    },

    watch: {
        showCancelledOrders(val) {
            this.$store.dispatch('setShowCancelledOrders', val)
            this.loadAsyncData()
        },
        showPaidOrders(val) {
            this.$store.dispatch('setShowPaidOrders', val)
            this.loadAsyncData()
        }
    }
}
</script>
